import React from 'react';
import './index.less';

const BlockTitle = (props: any) => {
  const { children, style } = props;

  const prefixClx = 'bidding-detail-block-title';
  return <div className={`${prefixClx}`} style={style}>{children}</div>;
};

export default BlockTitle;
